import { useCallback, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hymnsAction } from "../redux/hymn-slice";
import useHttps from "./useHttps";
import useReporting from "./useReporting";

const useHyms = () => {
   const { sendRequest } = useHttps();
   const dispatch = useDispatch();
   const { apiErrorReportingService, reportingService } = useReporting();
   const {
      hymns: { hymnsResponse, hymn },
   } = useSelector((state) => state);

   const [openDialog, setOpenDialog] = useState(false);

   const closeDeleteDialog = () => {
      setOpenDialog(false);
      dispatch(hymnsAction.setSingleHymn({}));
   };

   const openDeleteDialog = () => {
      setOpenDialog(true);
   };

   const getHymnsSuccess = (data) => {
      dispatch(hymnsAction.setHymnsResponse(data?.data));
   };

   const deleteHymn = () => {
      closeDeleteDialog();
      const config = {
         url: `hymn/remove-hymn/${hymn.id}`,
         method: "delete",
      };

      sendRequest(
         config,
         addHymnsSuccess,
         getHymnLoaderFunc,
         apiErrorReportingService
      );
   };

   const searchHymns = (value) => {
      const searchValue = value ? `hymnTitle:${value.trim()}*` : "";

      getHymns({ pageSize: 10, pageNo: 0, search: searchValue });
   };

   const openHymnsForm = () => {
      dispatch(hymnsAction.setOpenForm(true));
   };

   const createHymnLoaderFunc = (value) => {
      dispatch(hymnsAction.setCreateLoading(value));
   };

   const getHymnLoaderFunc = (value) => {
      dispatch(hymnsAction.setGetLoading(value));
   };

   const getHymnsError = (error) => {
      apiErrorReportingService(error);
      dispatch(hymnsAction.setHymnsResponse({}));
   };
   const getHymns = useCallback(
      ({ pageSize = 10, pageNo = 0, sortBy = "hymnNumber", search = "" }) => {
         const config = {
            method: "get",
            url: `hymn/get-hymns?pageSize=${pageSize}&pageNo=${pageNo}&sortBy=${sortBy}&search=${search}`,
         };

         sendRequest(config, getHymnsSuccess, getHymnLoaderFunc, getHymnsError);
      },
      [sendRequest]
   );

   const addHymnsSuccess = () => {
      closeHymnsForm();
      reportingService("Hymns updated Successfully", "success");
      const pageSize = hymnsResponse?.pageable?.pageSize ?? 10;
      const pageNo = hymnsResponse?.pageable?.pageNumber ?? 0;
      getHymns({ pageSize, pageNo });
   };

   const closeHymnsForm = () => {
      dispatch(hymnsAction.setSingleHymn({}));
      dispatch(hymnsAction.setOpenForm(false));
   };
   const addHymn = useCallback(
      (body) => {
         const config = {
            data: body,
            url: `hymn/create-update-hymn`,
            method: "post",
         };

         sendRequest(
            config,
            addHymnsSuccess,
            createHymnLoaderFunc,
            apiErrorReportingService
         );
      },
      [hymnsResponse, sendRequest]
   );

   return {
      getHymns,
      addHymn,
      openHymnsForm,
      closeHymnsForm,
      deleteHymn,
      openDeleteDialog,
      closeDeleteDialog,
      openDialog,
      searchHymns,
   };
};

export default useHyms;
